<ng-container *transloco="let t">
  <section [class]="tag().color">
    @if (icon()) {
      <i class="icon" [innerHTML]="icon()"></i>
    }
    @if (tag().textKey) {
      <p class="sans">
        <small>
          {{ t(tag().textKey) }}
        </small>
      </p>
    }
  </section>
</ng-container>
